/* Did this page load from a password-reset link?

   This lives in its own module for a reason that is about evaluation order,
   not tidiness. The Supabase client is created at module load with
   detectSessionInUrl, and the first thing it does is consume the
   `#access_token=…&type=recovery` fragment and scrub it from the address bar.
   Anything that asks afterwards sees a clean URL and cannot tell a reset link
   from an ordinary visit. An imported module is evaluated before the body of
   the module importing it, so reading the URL here happens first by
   construction rather than by keeping two statements in the right order.

   The PASSWORD_RECOVERY auth event covers the same ground, but it can fire
   before React has mounted and attached a listener — a race whose loser is a
   collector who clicked "reset my password" and got silently dropped into the
   app, still signed in, with no way to set one. The URL is the half that
   cannot be missed; the event is the half that survives a same-session
   re-trigger. The app uses both. */

/** @param {{hash?: string, search?: string}} loc */
export function isRecoveryUrl(loc) {
  if (!loc) return false;
  const hash = loc.hash || "";
  const search = loc.search || "";
  /* Anchored on a separator at both ends so this matches the real parameter
     and not a value that merely ends in it — `?next=/help/type=recovery` is
     someone reading a support page, not a reset link. Implicit flow puts the
     parameter in the fragment; checking the query too costs nothing and covers
     a provider or proxy that rewrites one into the other. */
  const pattern = /(?:^|[#?&])type=recovery(?:&|$)/;
  return pattern.test(hash) || pattern.test(search);
}

export const landedOnRecoveryLink =
  typeof window !== "undefined" && isRecoveryUrl(window.location);
